import { useLocation, useNavigate } from 'react-router-dom';
import {
  HomeIcon, UsersIcon, DocumentTextIcon, BellIcon,
  ChartBarIcon, CalendarDaysIcon, ArrowRightOnRectangleIcon, BookOpenIcon, AcademicCapIcon, SunIcon,
  MegaphoneIcon,
  ChatBubbleLeftRightIcon,
} from '@heroicons/react/24/outline';
import { signOut } from 'firebase/auth';
import { auth } from '@/services/firebase';
import { useAuthStore } from '@/stores/authStore';

const links = [
  { path: '/dashboard', label: 'Dashboard', icon: HomeIcon },
  { path: '/users', label: 'Users', icon: UsersIcon },
  { path: '/content', label: 'Content', icon: DocumentTextIcon },
  { path: '/review', label: 'Text review', icon: BookOpenIcon },
  { path: '/stories', label: 'माऊलींविषयी · Quiz', icon: AcademicCapIcon },
  { path: '/daily-verse', label: 'Daily Verse', icon: CalendarDaysIcon },
  { path: '/dnyankiran', label: 'ज्ञानकिरण', icon: SunIcon },
  { path: '/promotion', label: 'Promotion', icon: MegaphoneIcon },
  { path: '/testimonials', label: 'Website reviews', icon: ChatBubbleLeftRightIcon },
  { path: '/notifications', label: 'Notifications', icon: BellIcon },
  { path: '/analytics', label: 'Analytics', icon: ChartBarIcon },
];

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, setUser } = useAuthStore();

  async function handleLogout() {
    await signOut(auth);
    setUser(null, false);
  }

  return (
    <aside className="fixed left-0 top-0 bottom-0 w-64 bg-white border-r border-gray-200 flex flex-col z-10">
      <div className="px-6 py-5 border-b border-gray-200 flex items-center gap-3">
        <img src="/images/Logo.png" alt="ज्ञानेश्वरी" className="w-10 h-10 object-contain flex-shrink-0" />
        <div>
          <h1 className="text-lg font-bold text-amber-700">ज्ञानेश्वरी</h1>
          <p className="text-xs text-gray-500 mt-0.5">Admin Dashboard</p>
        </div>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
        {links.map(({ path, label, icon: Icon }) => {
          const active = location.pathname === path;
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                active
                  ? 'bg-amber-50 text-amber-700'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              <Icon className={`w-5 h-5 flex-shrink-0 ${active ? 'text-amber-600' : ''}`} />
              {label}
            </button>
          );
        })}
      </nav>

      <div className="px-3 py-3 border-t border-gray-200">
        <div className="px-3 py-2 mb-1">
          <p className="text-xs font-medium text-gray-700 truncate">{user?.email}</p>
          <p className="text-xs text-gray-400">Admin</p>
        </div>
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 hover:bg-red-50 hover:text-red-600 transition-colors"
        >
          <ArrowRightOnRectangleIcon className="w-5 h-5" />
          Sign Out
        </button>
      </div>
    </aside>
  );
}
